import * as React from "react";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  ListItem,
  List,
  Popover,
  Box,
  Tooltip,
  useTheme,
  Divider,
  Typography,
} from "@mui/material";

import { useState, useMemo, useEffect } from "react";
import { useLocation } from "react-router-dom";

import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import AllInboxIcon from "@mui/icons-material/AllInbox";
import TimelineIcon from "@mui/icons-material/Timeline";
import ImageSearchIcon from "@mui/icons-material/ImageSearch";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import ArchiveIcon from "@mui/icons-material/Archive";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import LogoutIcon from "@mui/icons-material/Logout";
import HolidayVillageSharpIcon from "@mui/icons-material/HolidayVillageSharp";
import MiscellaneousServicesSharpIcon from "@mui/icons-material/MiscellaneousServicesSharp";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import TableRowsRoundedIcon from "@mui/icons-material/TableRowsRounded";
import CategoryIcon from "@mui/icons-material/Category";
import AssignmentIcon from "@mui/icons-material/Assignment";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

import nav from "./nav";

/**
 * drawerVariant:
 * - "default": respeta theme.palette.mode
 * - "dark": fuerza textos e íconos blancos (ideal para drawer mobile con fondo oscuro)
 */
export const SideMenu = ({
  open,
  Logouts,
  isMobile = false,
  onNavigate,
  drawerVariant = "default",
}) => {
  const [openSubMenu, setOpenSubMenu] = useState({});
  const [selectedMenu, setSelectedMenu] = useState(
    localStorage.getItem("selected-menu") || null
  );
  const [selectedSubMenu, setSelectedSubMenu] = useState(
    localStorage.getItem("selected-submenu") || null
  );

  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverMenu, setPopoverMenu] = useState(null);

  const theme = useTheme();
  const location = useLocation();

  const backgroundMenu = theme.backgroundMenuItem?.default || "#1976d2";
  const menuBgActive = "rgba(25, 124, 203, 0.12)";

  const isDark = drawerVariant === "dark";
  const isLightTheme = theme.palette.mode === "light";

  const menuTextColor = isDark
    ? "rgba(255,255,255,0.88)"
    : isLightTheme ? "#637381" : "#FFFFFF";

  const menuTextActiveColor = isDark
    ? "#FFFFFF"
    : isLightTheme ? backgroundMenu : "#FFFFFF";

  const subMenuTextColor = isDark
    ? "rgba(255,255,255,0.82)"
    : isLightTheme ? "#637381" : "#FFFFFF";

  const subMenuActiveColor = isDark
    ? "#FFFFFF"
    : isLightTheme ? "#0A395F" : "#FFFFFF";

  const sectionLabelColor = isDark
    ? "rgba(255,255,255,0.45)"
    : isLightTheme ? "#94A3B8" : "#CBD5E1";

  const commonLabelStyles = {
    fontFamily: '"Public Sans", sans-serif',
    textTransform: "capitalize",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    lineHeight: 1.5,
    width: "100%",
    maxWidth: "100%",
    display: "block",
  };

  const labelStyles = {
    ...commonLabelStyles,
    fontSize: "0.8125rem",
    fontWeight: 500,
    color: menuTextColor,
    letterSpacing: "0.01em",
  };

  const activeLabelStyles = {
    ...commonLabelStyles,
    fontSize: "0.8125rem",
    fontWeight: 600,
    color: menuTextActiveColor,
    letterSpacing: "0.01em",
  };

  const labelSubMenuStyles = {
    ...commonLabelStyles,
    fontSize: "0.775rem",
    fontWeight: 400,
    color: subMenuTextColor,
    letterSpacing: "0.01em",
  };

  const labelSubMenuActiveStyles = {
    ...commonLabelStyles,
    fontSize: "0.775rem",
    fontWeight: 600,
    color: subMenuActiveColor,
    letterSpacing: "0.01em",
  };

  const activeIconStyles = { color: menuTextActiveColor, minWidth: 36 };
  const inactiveIconStyles = { minWidth: 36, color: menuTextColor, opacity: 0.72 };

  const activeMenuItemStyles = {
    backgroundColor: menuBgActive,
    borderRadius: "8px",
    borderLeft: `2px solid ${menuTextActiveColor}`,
    pl: "6px",
  };

  // nav() lee localStorage y construye el árbol — memoizado para que no cambie referencia en cada render
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const navigation = useMemo(() => nav(), []);

  const menuIcons = useMemo(
    () => [
      { name: "Usuarios, Roles ", icon: <SupervisedUserCircleIcon /> },
      { name: "Servicios ", icon: <SupportAgentIcon /> },
      { name: "Administracion de Cuentas ", icon: <ManageAccountsIcon /> },
      { name: "Relacion Cuentas-Servicios ", icon: <SettingsApplicationsIcon /> },
      { name: "Emision – Registracion ", icon: <ConfirmationNumberIcon /> },
      { name: "Parametros ", icon: <DisplaySettingsIcon /> },
      { name: "Ubicaciones ", icon: <AddLocationAltIcon /> },
      { name: "Procesos de Ingreso ", icon: <ImportExportIcon /> },
      { name: "Procesos internos ", icon: <AllInboxIcon /> },
      { name: "Consultas e Informes ", icon: <TimelineIcon /> },
      { name: "Digitalizaciones", icon: <ImageSearchIcon /> },
      { name: "Cajas Genericas", icon: <Inventory2Icon /> },
      { name: "Procesos de Retiro ", icon: <UnarchiveIcon /> },
      { name: "Procesos de Devolucion ", icon: <ArchiveIcon /> },
      { name: "Propiedades", icon: <HolidayVillageSharpIcon /> },
      { name: "Articulos", icon: <CategoryIcon /> },
      { name: "Informes", icon: <AssignmentIcon /> },
      { name: "Relacion Cuentas-Propiedades ", icon: <MiscellaneousServicesSharpIcon /> },
      { name: "Cuentas Corrientes ", icon: <AccountBalanceRoundedIcon /> },
      { name: "Modelos ", icon: <TableRowsRoundedIcon /> },
      { name: "Permisos ", icon: <LockOpenIcon /> },
      { name: "Modulos, menu ", icon: <ViewModuleIcon /> },
      { name: "Servicios de Guarda", icon: <Inventory2Icon /> },
      { name: "OCR - Textract", icon: <AutoAwesomeIcon /> },
    ],
    []
  );

  const convertToMenuData = (originalArray, menuIcons) => {
    return originalArray.map((item) => {
      const header = item.name;
      const menus = item?._children?.map((child) => {
        const matchingIcon = menuIcons.find(
          (iconItem) => iconItem.name.trim() === child.name.trim()
        );
        return {
          name: child.name,
          icon: matchingIcon ? matchingIcon.icon : null,
          submenus: child._children.map((submenu) => ({
            label: submenu.name,
            url: submenu.to,
            level: submenu.level,
          })),
        };
      });
      return { header, menus };
    });
  };

  const setearLevel = (level) => {
    localStorage.setItem("levelMenuActual", level);
  };

  const handleClick = (menu, event) => {
    localStorage.setItem("selected-menu", menu);
    setSelectedMenu(menu);

    if (menu === "Dashboard" || menu === "Cerrar Sesion") {
      setSelectedSubMenu(null);
      localStorage.setItem("selected-submenu", null);
      if (onNavigate) onNavigate();
      return;
    }

    if (isMobile || open) {
      setOpenSubMenu((prev) => ({ ...prev, [menu]: !prev[menu] }));
    } else {
      // Desktop cerrado: popover
      setPopoverMenu(menu);
      setAnchorEl(event.currentTarget);
    }
  };

  const handleSubMenuClick = (subMenu, menu, level) => {
    setearLevel(level);
    localStorage.setItem("selected-menu", menu);
    localStorage.setItem("selected-submenu", subMenu);
    setSelectedSubMenu(subMenu);
    setSelectedMenu(menu);
    if (onNavigate) onNavigate();
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setPopoverMenu(null);
  };

  const isPopoverOpen = Boolean(anchorEl);
  const popoverId = isPopoverOpen ? "sub-menu-popover" : undefined;

  // menuData es estable: solo se recalcula si navigation o menuIcons cambian (ambos memoizados)
  const menuData = useMemo(
    () => (navigation ? convertToMenuData(navigation, menuIcons) : null),
    // convertToMenuData es una función pura definida en el componente, no necesita estar en deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [navigation, menuIcons]
  );

  const showText = open || isMobile;

  // Sincroniza el menú activo con la ruta actual del navegador.
  // Solo depende de location.pathname — menuData es estable gracias a useMemo.
  useEffect(() => {
    if (!menuData) return;
    const currentPath = location.pathname;

    for (const headerData of menuData) {
      for (const menu of headerData.menus) {
        const matchingSubmenu = menu.submenus?.find(
          (sub) => sub.url && sub.url === currentPath
        );
        if (matchingSubmenu) {
          setSelectedMenu(menu.name);
          setSelectedSubMenu(matchingSubmenu.label);
          setOpenSubMenu((prev) => {
            // Evita actualizar si ya está expandido (previene re-renders innecesarios)
            if (prev[menu.name]) return prev;
            return { ...prev, [menu.name]: true };
          });
          localStorage.setItem("selected-menu", menu.name);
          localStorage.setItem("selected-submenu", matchingSubmenu.label);
          return;
        }
      }
    }

    if (currentPath === "/dashboard") {
      setSelectedMenu("Dashboard");
      setSelectedSubMenu(null);
    }
  }, [location.pathname, menuData]);

  /* ── Popover compartido (portal: funciona desde cualquier posición del DOM) ── */
  const popoverContent = menuData?.flatMap((headerData) => headerData.menus).map((menu, i) =>
    menu.submenus && popoverMenu === menu.name ? (
      <Popover
        key={i}
        id={popoverId}
        open={isPopoverOpen}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{ vertical: "center", horizontal: "right" }}
        transformOrigin={{ vertical: "center", horizontal: "left" }}
        PaperProps={{ elevation: 8, sx: { p: 0.5, borderRadius: "12px", minWidth: "200px", ml: 0.5 } }}
      >
        <Box sx={{ px: 1, py: 0.75 }}>
          <Typography variant="caption" sx={{ fontSize: "0.7rem", fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: "text.disabled", display: "block", px: 1, pb: 0.5 }}>
            {menu.name}
          </Typography>
          <Divider sx={{ mb: 0.5 }} />
        </Box>
        <List component="div" disablePadding sx={{ px: 0.5, pb: 0.5 }}>
          {menu.submenus.map((subMenu, subMenuIndex) => (
            <ListItem key={subMenuIndex} disablePadding>
              <ListItemButton
                sx={{ borderRadius: "8px", py: 0.5, ...(selectedSubMenu === subMenu.label ? { borderLeft: "3px solid #00A76F", bgcolor: "rgba(0, 167, 111, 0.06)", pl: "5px" } : { borderLeft: "3px solid transparent", pl: "5px" }) }}
                onClick={() => { handleSubMenuClick(subMenu.label, menu.name, subMenu.level); handlePopoverClose(); }}
                href={subMenu.url}
              >
                <ListItemIcon sx={{ minWidth: 24, mr: 0.5 }}>
                  <Box sx={{ width: selectedSubMenu === subMenu.label ? 8 : 5, height: selectedSubMenu === subMenu.label ? 8 : 5, borderRadius: "50%", bgcolor: selectedSubMenu === subMenu.label ? "#00A76F" : "#CBD5E1", flexShrink: 0 }} />
                </ListItemIcon>
                <ListItemText primary={subMenu.label} primaryTypographyProps={selectedSubMenu === subMenu.label ? labelSubMenuActiveStyles : labelSubMenuStyles} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Popover>
    ) : null
  );

  return (
    <Box display="flex" flexDirection="column" height="100%" sx={{ overflow: "hidden" }}>

      {!showText ? (
        /* ── MODO CONTRAÍDO: todos los ítems en una columna distribuida ── */
        <Box
          flex="1"
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
            overflow: "hidden",
            px: 0.75,
            py: 0.5,
          }}
        >
          {/* Dashboard */}
          <Tooltip title="Dashboard" placement="right">
            <ListItemButton
              onClick={(e) => handleClick("Dashboard", e)}
              href="/dashboard"
              sx={{ borderRadius: "8px", justifyContent: "center", minHeight: 36, px: 1, ...(selectedMenu === "Dashboard" ? { ...activeMenuItemStyles, borderLeft: "none", bgcolor: menuBgActive } : {}) }}
            >
              <ListItemIcon sx={{ ...( selectedMenu === "Dashboard" ? activeIconStyles : inactiveIconStyles), minWidth: "unset" }}>
                <DashboardIcon sx={{ fontSize: 20 }} />
              </ListItemIcon>
            </ListItemButton>
          </Tooltip>

          {/* Módulos (aplanados) */}
          {menuData?.flatMap((headerData, hIdx) =>
            headerData.menus.map((menu, mIdx) => (
              <Tooltip key={`${hIdx}-${mIdx}`} title={menu.name} placement="right">
                <ListItemButton
                  onClick={(e) => handleClick(menu.name, e)}
                  sx={{ borderRadius: "8px", justifyContent: "center", minHeight: 36, px: 1, ...(selectedMenu === menu.name ? { ...activeMenuItemStyles, borderLeft: "none", bgcolor: menuBgActive } : {}) }}
                >
                  <ListItemIcon sx={{ ...(selectedMenu === menu.name ? activeIconStyles : inactiveIconStyles), minWidth: "unset" }}>
                    {React.cloneElement(menu.icon, { sx: { fontSize: 20 } })}
                  </ListItemIcon>
                </ListItemButton>
              </Tooltip>
            ))
          )}

          {popoverContent}
        </Box>
      ) : (
        /* ── MODO EXPANDIDO: layout original con scroll ── */
        <Box
          flex="1"
          sx={{
            overflowY: "auto",
            overflowX: "hidden",
            "&::-webkit-scrollbar": { width: "4px" },
            "&::-webkit-scrollbar-track": { background: "transparent" },
            "&::-webkit-scrollbar-thumb": {
              background: isDark ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.15)",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: isDark ? "rgba(255,255,255,0.35)" : "rgba(0,0,0,0.28)",
            },
          }}
        >
          {/* Dashboard */}
          <List dense disablePadding sx={{ px: 1, pt: 1 }}>
            <ListItem disablePadding>
              <ListItemButton
                onClick={(e) => handleClick("Dashboard", e)}
                href="/dashboard"
                sx={{ borderRadius: "8px", mb: 0.5, borderLeft: "2px solid transparent", ...(selectedMenu === "Dashboard" ? activeMenuItemStyles : {}) }}
              >
                <ListItemIcon sx={selectedMenu === "Dashboard" ? activeIconStyles : inactiveIconStyles}>
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="Dashboard" primaryTypographyProps={selectedMenu === "Dashboard" ? activeLabelStyles : labelStyles} />
              </ListItemButton>
            </ListItem>
          </List>

          <Divider sx={{ mx: 1, mb: 0.5 }} />

          {/* Módulos */}
          <List dense disablePadding sx={{ px: 1, pb: 1 }}>
            {menuData?.map((headerData, index) => (
              <React.Fragment key={index}>
                <Box sx={{ pt: index === 0 ? 0.75 : 1.25, pb: 0.5, px: 1.5 }}>
                  <Typography
                    variant="caption"
                    sx={{ fontFamily: '"Public Sans", sans-serif', fontSize: "0.65rem", fontWeight: 600, letterSpacing: "0.10em", textTransform: "uppercase", color: sectionLabelColor, display: "block", lineHeight: 1 }}
                  >
                    {headerData.header}
                  </Typography>
                </Box>

                {headerData.menus.map((menu, menuIndex) => (
                  <div key={menuIndex}>
                    <ListItem disablePadding sx={{ mb: 0.25 }}>
                      <ListItemButton
                        onClick={(e) => handleClick(menu.name, e)}
                        sx={{ borderRadius: "8px", borderLeft: "2px solid transparent", ...(selectedMenu === menu.name ? activeMenuItemStyles : {}) }}
                      >
                        <ListItemIcon sx={selectedMenu === menu.name ? activeIconStyles : inactiveIconStyles}>
                          {menu.icon}
                        </ListItemIcon>
                        <ListItemText primary={menu.name} primaryTypographyProps={selectedMenu === menu.name ? activeLabelStyles : labelStyles} />
                        {menu.submenus && (
                          openSubMenu[menu.name]
                            ? <ExpandLess sx={{ fontSize: 16, color: selectedMenu === menu.name ? menuTextActiveColor : menuTextColor, flexShrink: 0, opacity: 0.7 }} />
                            : <ExpandMore sx={{ fontSize: 16, color: selectedMenu === menu.name ? menuTextActiveColor : menuTextColor, flexShrink: 0, opacity: 0.7 }} />
                        )}
                      </ListItemButton>
                    </ListItem>

                    {menu.submenus && (
                      <Collapse in={openSubMenu[menu.name]} timeout={180} unmountOnExit>
                        <List component="div" disablePadding sx={{ mb: 0.5 }}>
                          {menu.submenus.map((subMenu, subMenuIndex) => (
                            <ListItem key={subMenuIndex} disablePadding sx={{ pl: 1 }}>
                              <ListItemButton
                                onClick={() => handleSubMenuClick(subMenu.label, menu.name, subMenu.level)}
                                href={subMenu.url}
                                sx={{
                                  borderRadius: "8px",
                                  py: 0.4,
                                  ...(selectedSubMenu === subMenu.label
                                    ? { borderLeft: "3px solid #00A76F", bgcolor: "rgba(0, 167, 111, 0.06)", pl: "5px" }
                                    : { borderLeft: "3px solid transparent", pl: "5px" }),
                                }}
                              >
                                <ListItemIcon sx={{ pl: 1.5, minWidth: 28 }}>
                                  <Box sx={{
                                    width: selectedSubMenu === subMenu.label ? 8 : 5,
                                    height: selectedSubMenu === subMenu.label ? 8 : 5,
                                    borderRadius: "50%",
                                    flexShrink: 0,
                                    bgcolor: selectedSubMenu === subMenu.label
                                      ? "#00A76F"
                                      : isDark ? "rgba(255,255,255,0.35)" : isLightTheme ? "#CBD5E1" : "#64748B",
                                  }} />
                                </ListItemIcon>
                                <ListItemText
                                  primary={subMenu.label}
                                  primaryTypographyProps={selectedSubMenu === subMenu.label ? labelSubMenuActiveStyles : labelSubMenuStyles}
                                />
                              </ListItemButton>
                            </ListItem>
                          ))}
                        </List>
                      </Collapse>
                    )}
                  </div>
                ))}
              </React.Fragment>
            ))}
          </List>
        </Box>
      )}

      {/* ── Footer fijo ── */}
      <Box sx={{ flexShrink: 0 }}>
        <Divider sx={{ mx: 1 }} />
        <List dense disablePadding sx={{ px: 1, py: 0.5 }}>
          <ListItem disablePadding>
            <Tooltip title={!showText ? "Cerrar Sesión" : ""} placement="right">
              <ListItemButton
                onClick={Logouts}
                sx={{ borderRadius: "10px", ...(selectedMenu === "Cerrar Sesion" ? activeMenuItemStyles : {}) }}
              >
                <ListItemIcon sx={selectedMenu === "Cerrar Sesion" ? activeIconStyles : inactiveIconStyles}>
                  <LogoutIcon color="error" />
                </ListItemIcon>
                {showText && (
                  <ListItemText primary="Cerrar Sesión" primaryTypographyProps={selectedMenu === "Cerrar Sesion" ? activeLabelStyles : labelStyles} />
                )}
              </ListItemButton>
            </Tooltip>
          </ListItem>
        </List>
      </Box>
    </Box>
  );
};
